import * as React from "react";
import { useTranslation } from "react-i18next";
import { AdvertisementsListProps } from ".";
import useSnackbarAlert from "../../../utils/snackbarHandlers";
import { BorderColor, Delete, Visibility } from '@mui/icons-material';
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, LinearProgress, Tooltip } from '@mui/material';
import { GridCellParams, GridColDef, DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdsListRenderer: React.FC<AdvertisementsListProps> = ({ adsData, totalCount, loading, paginationModel, setPaginationModel, setRefreshTable }) => {
  const { t } = useTranslation();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const navigate = useNavigate();
  const [dialogBox, setDialogBox] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState();
  const [deleteProductTitle, setDeleteProductTitle] = React.useState();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';

  const handleDelete = React.useCallback((id: any) => {
    axios.delete(`${apiBaseURL}/api/advertisement/deleteAdvertisement?id=${id}`)
      .then((res: any) => {
        setDialogBox(false);
        setRefreshTable(Math.random());
        showSuccessMessage(t("advertisementDeletedSuccessMessage"));
      })
      .catch((error: Error) => showErrorMessage(error))
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'productTitle',
      headerName: 'Product Title',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'productPriceDescription',
      headerName: 'Price description',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'adLocation',
      headerName: 'Advertisement Location',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
      valueFormatter: (params: any) => {
        const creationDate = params.value;
        return (
          (creationDate?.split("T")[0] as string) +
          " " +
          (creationDate?.split("T")[1] as string)?.slice(0, 8)
        );
      },
    },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      width: 200,
      align: "center",
      headerAlign: "center",
      flex: 1,
      valueFormatter: (params: any) => {
        const creationDate = params.value;
        return (
          (creationDate?.split("T")[0] as string) +
          " " +
          (creationDate?.split("T")[1] as string)?.slice(0, 8)
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
      renderCell: (params: GridCellParams) => {
        return (
          <ButtonGroup size="small" color="inherit" aria-label="group action buttons">
            <Tooltip title="View">
              <Button
                onClick={(e) => navigate(`/shopOwner/advertisements/view/${params.row.id}`)}
              >
                <Visibility fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip title="Edit">
              <Button
                onClick={(e) => navigate(`/shopOwner/advertisements/edit/${params.row.id}`)}
              >
                <BorderColor fontSize="small" />
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                onClick={() => {
                  setDialogBox(true);
                  setDeleteId(params.row.id);
                  setDeleteProductTitle(params.row.productTitle)
                }}
              >
                <Delete fontSize="small" />
              </Button>
            </Tooltip>
          </ButtonGroup>
        );
      },
      flex: 1,
    },
  ];

  return (
    <>
      <Grid className="w-full" style={{
        marginTop: "1%",
        height: "585px",
      }}>
        <DataGrid
          rows={adsData}
          loading={loading}
          columns={columns}
          rowCount={totalCount}
          pageSizeOptions={[10, 20, 50, 100]}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          getRowId={(row: any) => row.id}
          disableColumnSelector
          disableRowSelectionOnClick
          sx={{
            '& .MuiDataGrid-main': {
              borderColor: "#DAA520",
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: "#F5F5E6",

            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 600,

            },
            '& .MuiDataGrid-row.Mui-odd': {
              backgroundColor: "#F5F5E6",
            }
          }}
          getRowClassName={(params) => {
            return params.id as number % 2 === 0 ? 'Mui-even' : 'Mui-odd'
          }
          }
          columnBuffer={0}
        />
      </Grid>
      <Dialog
        open={dialogBox}
        onClose={() => setDialogBox(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('deleteAd')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('deleteAdConfirmation') + deleteProductTitle + "?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogBox(false)}>{t('disagree')}</Button>
          <Button onClick={() => handleDelete(deleteId)} autoFocus>
            {t('agree')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdsListRenderer;
